import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { semanticColors, greyScaleColors } from "../../../Globals/styles";
import animations from "../../../Globals/animations";
import SuggestSelectInput from "../../../Common/suggestSelectInput";
import { Scrollbars } from "react-custom-scrollbars";
import EmployeeDropableTrashcan from "../../../Common/employeeDropableTrashcan";
import PoolChart from "../../../Common/poolChart";
import Employee from "./employee";

class EmployeeOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeSuggestionVal: { id: null, name: null },
    };
  }
  onEmployeeSuggestChange = (val) => {
    const { addEmployee } = this.props;
    if (val.id) {
      this.setState({
        employeeSuggestionVal: { name: null, id: null },
      });
      //add the employee to the list
      addEmployee(val);
    } else {
      this.setState({
        employeeSuggestionVal: val,
      });
    }
  };

  render() {
    const {
      employeeIsDragging,
      employees,
      setEmployeeIsDragging,
      getTotalActivityHours,
      rmEmployeeFromProject,
      getEmployeeSuggestions,
      employeeSuggestions,
      canDrag,
      userAcks,
    } = this.props;

    let pool = 0;
    let employeeNodes = employees.map((employee, index) => {
      // is disabled, needs to ack
      let disabled = userAcks !== undefined;
      if (disabled) {
        const id = employee
          ? employee.id
            ? employee.id.toLowerCase()
            : ""
          : "";
        if (userAcks[id] && userAcks[id].safety && userAcks[id].understood) {
          disabled = false;
        }
      }
      //add both to the pool
      employee.timeRegistrations.forEach((t) => {
        if (t.checkIn) {
          pool += t.hours;
        } else {
          pool += t.hours + t.nightHours;
        }
      });
      if (employee.break > 0) {
        pool -= employee.break;
      }
      return (
        <Employee
          disabled={disabled}
          key={employee.id}
          employee={employee}
          index={index}
          setEmployeeIsDragging={(bool) => setEmployeeIsDragging(bool)}
          canDrag={canDrag}
          rmEmployeeFromProject={rmEmployeeFromProject}
        />
      );
    });

    return (
      <div
        style={[
          styles.leftInnerContainer,
          !canDrag && styles.leftInnerContainerCantDrag,
        ]}
      >
        <div style={styles.innerContainerHeader}>
          <h3 style={styles.marginBottom}>Timepulje</h3>
          <div style={styles.canvas}>
            <PoolChart pool={pool} registered={getTotalActivityHours()} />
          </div>
          {canDrag ? (
            <div style={styles.addEmployeeContainer}>
              <h3 style={styles.marginBottom}>Mandskab</h3>
              {employeeIsDragging ? (
                <div style={styles.employeeDropableTrashcanContainer}>
                  <EmployeeDropableTrashcan
                    rmEmployeeFromProject={rmEmployeeFromProject}
                  />
                </div>
              ) : (
                <SuggestSelectInput
                  type="text"
                  onQuery={getEmployeeSuggestions}
                  suggestions={
                    this.state.employeeSuggestionVal.name
                      ? employeeSuggestions
                      : []
                  }
                  placeholder="Tilføj nyt mandskab"
                  onChange={this.onEmployeeSuggestChange}
                  value={this.state.employeeSuggestionVal}
                  inputStyle={styles.suggestInput}
                >
                  <i
                    className="fa fa-user-plus"
                    aria-hidden="true"
                    style={styles.userPlus}
                  ></i>
                </SuggestSelectInput>
              )}
            </div>
          ) : (
            <h3 style={styles.marginBottom}>Mandskab</h3>
          )}

          <div style={styles.divider} />
        </div>
        <Scrollbars style={{ height: "100%", width: "100%" }}>
          {employeeNodes.length === 0 ? (
            <img
              alt="ingen medarbejdere"
              src="../../../..\images\emptyStates\Emptystate_Mandskab.png"
            />
          ) : (
            employeeNodes
          )}
        </Scrollbars>
      </div>
    );
  }
}

var styles = {
  content: {
    height: "100%",
  },
  innerContainer: {
    height: "100%",
    backgroundColor: semanticColors.default,
  },
  fadeOut: {
    animation: animations.fadeOut,
  },
  leftSideContainer: {
    height: "100%",
    padding: "30px 0px 90px 0px",
    position: "relative",
  },
  height100: {
    height: "100%",
  },
  width100: {
    width: "100%",
  },
  activityTableContainer: {
    height: "100%",
    paddingRight: "0px",
  },
  datepickerRow: {
    marginBottom: "30px",
    width: "100%",
    height: "42px",
  },
  leftSide: {
    borderRight: "1px solid " + greyScaleColors.greyLighter,
  },
  nightDayContainer: {
    margin: "0",
  },
  DNButton: {
    height: "35px",
    fontSize: "20px",
    lineHeight: "1em",
  },
  dayBtn: {
    borderRadius: "2px 0px 0px 2px",
  },
  nightBtn: {
    borderRadius: "0px 2px 2px 0px",
  },
  nightDayActive: {
    backgroundColor: semanticColors.info,
    color: semanticColors.default,
  },
  leftInnerContainer: {
    width: "100%",
    height: "100%",
    maxWidth: "250px",
    marginLeft: "auto",
    marginRight: "auto",
    paddingRight: "12px",
    paddingTop: "225px",
    position: "relative",
  },
  leftInnerContainerCantDrag: {
    paddingTop: "173px",
  },
  innerContainerHeader: {
    position: "absolute",
    height: "220px",
    left: "0",
    top: "-20px",
    paddingRight: "12px",
    width: "100%",
  },
  divider: {
    margin: "12px 0",
    borderTop: "1px solid " + semanticColors.mainBackground,
  },
  addEmployeeContainer: {
    /*position : 'absolute',
    top: '150px',
    left: '12px',
    right: '12px',*/
    position: "relative",
    height: "67px",
  },
  suggestInput: {
    height: "42px",
    paddingLeft: "40px",
  },
  marginBottom: {
    marginBottom: "10px",
  },
  userPlus: {
    position: "absolute",
    top: "10px",
    left: "10px",
    fontSize: "20px",
  },
  canvas: {
    margin: "0 auto 30px auto",
    maxWidth: "220px",
  },
  employeeDropableTrashcanContainer: {
    position: "relative",
  },
};
EmployeeOverview.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      absence: PropTypes.shape({
        date: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        absenceCode: PropTypes.string,
      }),
      timeRegistrations: PropTypes.arrayOf(
        PropTypes.shape({
          hours: PropTypes.number.isRequired,
          nightHours: PropTypes.number.isRequired,
          employeeFunction: PropTypes.string,
        })
      ).isRequired,
    })
  ).isRequired,
  setEmployeeIsDragging: PropTypes.func.isRequired,
  getTotalActivityHours: PropTypes.func.isRequired,
  employeeIsDragging: PropTypes.bool.isRequired,
  rmEmployeeFromProject: PropTypes.func.isRequired,
  getEmployeeSuggestions: PropTypes.func.isRequired,
  employeeSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  addEmployee: PropTypes.func.isRequired,
  canDrag: PropTypes.bool.isRequired,
};
export default Radium(EmployeeOverview);



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/employeeOverview.jsx